import React, { useCallback } from "react";
import { useState, useRef } from "react";
import "./Admin.css";
import { RxDashboard } from "react-icons/rx";
import { IoCalendarClearOutline } from "react-icons/io5";
import { LuFolderCog } from "react-icons/lu";
import { HiOutlineMegaphone } from "react-icons/hi2";
import { PiCourtBasketball } from "react-icons/pi";
import { PiTable } from "react-icons/pi";
import { Button } from "primereact/button";
import "primeicons/primeicons.css";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { InputText } from "primereact/inputtext";
import "primereact/resources/themes/lara-light-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import admin from "../../assets/AdminImages/admin.png";
import Dashboard from "../Dashboard/Dashboard";
import ContactRequest from "../ContactRequest/ContactRequest";
import Feedback from "../Feedbacks/Feedback";
import Announcement from "../Announcement/Announcement";
import KBARegistration from "../Registration/KBARegistration";
import SlotBooking from "../SlotBooking/SlotBooking";
import { Tooltip } from "primereact/tooltip";
import { useEffect } from "react";
import kosmoslogo from "../../assets/kosmos-logo.png";
import shopicon from "../../assets/storefront-light.svg";
import axios from "axios";
import accept from "../../assets/accept.png";
import RuwiBranch from "../RuwiBranch/RuwiBranch";
import GhalaBranch from "../GhalaBranch/GhalaBranch";
import RiyazBranch from "../RiyazBranch/RiyazBranch";
import { addPrice, getPrice } from "../../Services/BackendUrl";
import Loader from "../Components/Loader";
import { ShowNotifications } from "./Notifications/ShowNotifications";
import dayjs from "dayjs";
import isToday from "dayjs/plugin/isToday";
import isYesterday from "dayjs/plugin/isYesterday";
import { showNotificationsURL } from "../../Services/BackendUrl";
import { encryptedAuth } from "../../Services/EncryptData";
import BookingCalander from "../BookingCalander/BookingCalander"

dayjs.extend(isToday);
dayjs.extend(isYesterday);

const Admin = () => {
  const [showPopup, setShowPopup] = useState(false);
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [price, setPrice] = useState("");
  const [currentAmount, setCurrentAmount] = useState(0);
  const [activePage, setActivePage] = useState(() => {
  return sessionStorage.getItem("activePage") || "dashboard"; 
});

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 889);
  const [isExporting, setIsExporting] = useState(false);

  const [showKbaDataTable, setShowKbaDataTable] = useState(false);
  const [showSearch, isShowSearch] = useState(true);
  const [isShowEditIcon, setIsShowEditIcon] = useState(true);

  const [messages, setMessages] = useState([]);
  const [visibleNotificatios, setVisibleNotifications] = useState(false);
  const ws = useRef(null);
  const heartbeatRef = useRef(null);
  const reconnectRef = useRef(null);
  const RECONNECT_INTERVAL = 5000;
  const HEARTBEAT_INTERVAL = 300000;
  const [adminNotifications, setAdminNotifications] = useState([]);
  const [todayNotifications, setTodayNotifications] = useState([]);
  const [yesterdayNotifications, setYesterdayNotifications] = useState([]);
  const [olderNotifications, setOlderNotifications] = useState([]);
     const [showCustomerData,setShowCustomerData] = useState()

  const handleLogout = () => {
    sessionStorage.removeItem("isAdminAuthenticated");
    localStorage.removeItem("isAdminAuthenticated");
    sessionStorage.removeItem("activePage");
    window.location.replace("/login");
  };

  const connectWebSocket = useCallback(() => {
    const websocketUrl =
      "wss://1cdbmm4u56.execute-api.ap-south-1.amazonaws.com/Prod/";
    ws.current = new WebSocket(websocketUrl);
    ws.current.onopen = () => {
      if (ws.current.readyState === WebSocket.OPEN) {
        ws.current.send(JSON.stringify({ action: "admin/notification" }));
      } else {
        console.warn(
          "⚠️ WebSocket not open yet when trying to send notification."
        );
      }
      heartbeatRef.current = setInterval(() => {
        if (ws.current.readyState === WebSocket.OPEN) {
          ws.current.send(JSON.stringify({ action: "ping" }));
        }
      }, HEARTBEAT_INTERVAL);
    };

    ws.current.onmessage = (event) => {
      try {
        const msg = JSON.parse(event.data);
        if (msg.type && msg.payload !== undefined) {
          setMessages((prev) => [
            ...prev,
            `[${msg.type}] ${JSON.stringify(msg.payload)}`,
          ]);
        } else {
          console.warn("🟡 Ignored message without type/payload:", msg);
        }
      } catch (err) {
        console.error("❌ Failed to parse WebSocket message:", event.data);
      }
    };

    ws.current.onerror = (err) => {
      console.error("❌ WebSocket error", err);
    };

    ws.current.onclose = () => {
      console.warn("🔌 WebSocket disconnected");
      clearInterval(heartbeatRef.current);
      reconnectRef.current = setTimeout(() => {
        connectWebSocket();
      }, RECONNECT_INTERVAL);
    };
  }, [setMessages]);


  
  useEffect(() => {
    connectWebSocket();

    return () => {
      ws.current?.close();
      clearInterval(heartbeatRef.current);
      clearTimeout(reconnectRef.current);
    };
  }, [connectWebSocket]);

  const handlePageChange = (pageName) => {
    setIsExporting(true);
    setActivePage(pageName);
    sessionStorage.setItem("activePage",pageName);
    setShowKbaDataTable(true);
    isShowSearch(true);
    setIsShowEditIcon(true);
    setShowCustomerData(false)
    setTimeout(() => {
      setIsExporting(false);
    }, 2000);
  };

  const handleUpdate = async () => {
    try {
      const response = await axios.post(
        addPrice,
        { price: Number(price) },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Encrypted ${encryptedAuth}`
          },
        }
      );

      if (response.status === 200) {
        setShowSnackbar(true);
        setCurrentAmount(Number(price));
        setTimeout(() => setShowSnackbar(false), 3000);
      }
    } catch (error) {
      console.error("Error updating price amount:", error);
    }
  };

  useEffect(() => {
    const fetchAmount = async () => {
      try {
        const response = await axios.get(getPrice, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Encrypted ${encryptedAuth}`
          },
        });
        setCurrentAmount(response.data.price);
      } catch (error) {
        console.error("Error fetching amount:", error);
      }
    };

    fetchAmount();
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 889);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const groupNotificationsByDate = (adminnotifications) => {
    const today = [];
    const yesterday = [];
    const older = [];

    const now = dayjs().tz("Asia/Kolkata").startOf("day");
    const yesterdayDate = now.subtract(1, "day").startOf("day");

    adminnotifications.notifications.forEach((n) => {
      const date = dayjs.utc(n.createdAt).tz("Asia/Kolkata");
      if (date.isToday()) {
        today.push(n);
      } else if (date.isSame(yesterdayDate, "day")) {
        yesterday.push(n);
      } else {
        older.push(n);
      }
    });

    setTodayNotifications(today);
    setYesterdayNotifications(yesterday);
    setOlderNotifications(older);

    return { today, yesterday, older };
  };

const getAdminNotification = useCallback(async () => {
  try {
    const response = await axios.get(showNotificationsURL, {
      headers: {
        Authorization: `Encrypted ${encryptedAuth}`,
        "Content-Type": "application/json",
      },
    });
    setAdminNotifications(response.data);
    groupNotificationsByDate(response.data);
  } catch (error) {
    console.error("❌ Failed to fetch admin notification:", error);
  }
}, []);

  useEffect(() => {
    getAdminNotification();
  }, [getAdminNotification]);

  return (
    <>
      <div className="admin-container">
        <div className="blur-background">
          <span className="blur-circle"></span>
          <span className="blur-circle"></span>
          <span className="blur-circle"></span>
          <span className="blur-circle"></span>
          <span className="blur-circle"></span>
        </div>
        <div className="sidebar-container">
          <div>
            <p className="admin-title">KOSMOS</p>
            <img
              src={kosmoslogo}
              className="kosmos-titleimage"
              alt="kosmos-logo"
            ></img>
            <div className="mainmenu-container">
              <p className="mainmenu-title">Main Menu</p>
              <div className="mainmenuoptions-container">
                <div className="mainmenuoptions-subcontainer">
                  <div
                    className={`mainmenuoptionsicon-container ${activePage === "dashboard" ? "active" : ""
                      }`}
                    onClick={() => handlePageChange("dashboard")}
                  >
                    <RxDashboard
                      className="mainmenuoptions-icon main-dashboard"
                      data-pr-tooltip={isMobile ? "dashboard" : null}
                      data-pr-position="mouse"
                    />
                    {isMobile && (
                      <Tooltip
                        target=".main-dashboard"
                        className="custom-tooltip"
                      />
                    )}
                    <p className="mainmenu-options">Dashboard</p>
                  </div>
                  <div
                    className={`mainmenuoptionsicon-container ${activePage === "contactrequest" ? "active" : ""
                      }`}
                    onClick={() => handlePageChange("contactrequest")}
                  >
                    <IoCalendarClearOutline
                      className="mainmenuoptions-icon main-request"
                      data-pr-tooltip={isMobile ? "contact request" : null}
                      data-pr-position="mouse"
                    />
                    {isMobile && (
                      <Tooltip
                        target=".main-request"
                        className="custom-tooltip"
                      />
                    )}
                    <p className="mainmenu-options">Contact Requests</p>
                  </div>
                  <div
                    className={`mainmenuoptionsicon-container ${activePage === "feedback" ? "active" : ""
                      }`}
                    onClick={() => handlePageChange("feedback")}
                  >
                    <LuFolderCog
                      className="mainmenuoptions-icon main-feedback"
                      data-pr-tooltip={isMobile ? "feedback" : null}
                      data-pr-position="mouse"
                    />
                    {isMobile && (
                      <Tooltip
                        target=".main-feedback"
                        className="custom-tooltip"
                      />
                    )}
                    <p className="mainmenu-options">Feedback</p>
                  </div>
                  <div
                    className={`mainmenuoptionsicon-container ${activePage === "announcement" ? "active" : ""
                      }`}
                    onClick={() => handlePageChange("announcement")}
                  >
                    <HiOutlineMegaphone
                      className="mainmenuoptions-icon main-announcement"
                      data-pr-tooltip={isMobile ? "announcements" : null}
                      data-pr-position="mouse"
                    />
                    {isMobile && (
                      <Tooltip
                        target=".main-announcement"
                        className="custom-tooltip"
                      />
                    )}
                    <p className="mainmenu-options">Announcements</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="academy-container">
              <p className="mainmenu-title academy-title">Academy</p>
              <div className="academy-secontainer">
                <div className="academy-subcontainer">
                  <div
                    className={`mainmenuoptionsicon-container ${activePage === "registration" ? "active" : ""
                      }`}
                    onClick={() => handlePageChange("registration")}
                  >
                    <PiTable
                      className="mainmenuoptions-icon academy-register"
                      data-pr-tooltip={isMobile ? "registerartion" : null}
                      data-pr-position="mouse"
                    />
                    {isMobile && (
                      <Tooltip
                        target=".academy-register"
                        className="custom-tooltip"
                      />
                    )}
                    <p className="academy-options">KBA Registration</p>
                  </div>
                  <div
                    className={`mainmenuoptionsicon-container ${activePage === "slotbooking" ? "active" : ""
                      }`}
                    onClick={() => handlePageChange("slotbooking")}
                  >
                    <PiCourtBasketball
                      className="mainmenuoptions-icon academy-slot"
                      data-pr-tooltip={isMobile ? "slot booking" : null}
                      data-pr-position="mouse"
                    />
                    {isMobile && (
                      <Tooltip
                        target=".academy-slot"
                        className="custom-tooltip"
                      />
                    )}
                    <p className="academy-options">Slot Booking</p>
                  </div>
                  <div
  className={`mainmenuoptionsicon-container ${
    activePage === "bookingcalendar" ? "active" : ""
  }`}
  onClick={() => handlePageChange("BookingCalander")}
>
  <img
    src={require("../../assets/bulkbooking.png")}
    alt="Booking Calendar"
    className={`w-5 h-5 object-contain cursor-pointer transition-transform duration-300 
      ${activePage === "bookingcalendar" ? "scale-110" : "hover:scale-110"}`}
  />

  {isMobile && (
    <Tooltip target=".booking-calendar" className="custom-tooltip" />
  )}

  <p className="academy-options text-white text-sm mt-1">Bulk Booking</p>
</div>


                </div>
              </div>
            </div>
            <div className="branches-container">
              <p className="mainmenu-title branches-title">Branches</p>
              <div className="branches-secontainer">
                <div className="branches-subcontainer">
                  <div
                    className={`mainmenuoptionsicon-container ${activePage === "ruwibranch" ? "active" : ""
                      }`}
                    onClick={() => handlePageChange("ruwibranch")}
                  >
                    <img
                      src={shopicon}
                      alt="Logo"
                      className="mainmenuoptions-branchesicon"
                      data-pr-tooltip={isMobile ? "ruwi branch" : null}
                      data-pr-position="mouse"
                    />
                    {isMobile && (
                      <Tooltip
                        target=".branches-ruwibranch"
                        className="custom-tooltip"
                      />
                    )}
                    <p className="academy-options">Ruwi Branch</p>
                  </div>
                  <div
                    className={`mainmenuoptionsicon-container ${activePage === "ghalabranch" ? "active" : ""
                      }`}
                    onClick={() => handlePageChange("ghalabranch")}
                  >
                    <img
                      src={shopicon}
                      alt="Logo"
                      className="mainmenuoptions-branchesicon"
                      data-pr-tooltip={isMobile ? "ghala branch" : null}
                      data-pr-position="mouse"
                    />
                    {isMobile && (
                      <Tooltip
                        target=".branches-ghalabranch"
                        className="custom-tooltip"
                      />
                    )}
                    <p className="academy-options">Ghala Branch</p>
                  </div>
                  <div
                    className={`mainmenuoptionsicon-container ${activePage === "riyazbranch" ? "active" : ""
                      }`}
                    onClick={() => handlePageChange("riyazbranch")}
                  >
                    <img
                      src={shopicon}
                      alt="Logo"
                      className="mainmenuoptions-branchesicon"
                      data-pr-tooltip={isMobile ? "riyaz branch" : null}
                      data-pr-position="mouse"
                    />
                    {isMobile && (
                      <Tooltip
                        target=".branches-riyazbranch"
                        className="custom-tooltip"
                      />
                    )}
                    <p className="academy-options">Riaz Branch</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="logout-container">
            <Button
              label="Log Out"
              icon="pi pi-sign-out"
              iconPos="left"
              className="custom-logout-button"
              data-pr-tooltip={isMobile ? "Log Out" : null}
              data-pr-position="mouse"
              onClick={handleLogout}
            />
            {isMobile && (
              <Tooltip
                target=".custom-logout-button"
                className="custom-tooltip"
                position="bottom"
              />
            )}
          </div>
        </div>
        <div className="showcontent-container">
          <div className="nav-container">
            <div className="navbar-container">
              <div className="searchbar-admin-wrapper">
                <div className="searchbar-admin-container">
                  <IconField iconPosition="left">
                    <InputIcon className="pi pi-search" />
                    <InputText placeholder="Search here" />
                  </IconField>
                </div>
                <img
                  src={admin}
                  className="admin-image admin-avatar-inside-input"
                  alt="adminphoto"
                />
              </div>
              <div className="navicons-section">
                <div className="navicons-container">
                  <i
                    className="pi pi-bell nav-icons"
                    onClick={() => {
                      setVisibleNotifications(true);
                      getAdminNotification();
                    }}
                  ></i>

                  {(messages.length > 0 ||

                    todayNotifications?.some((n) => n.is_viewed === false)
                    ||

                    yesterdayNotifications?.some((n) => n.is_viewed === false)
                    ||

                    olderNotifications?.some((n) => n.is_viewed === false)
                  ) && (
                      <i
                        className="pi pi-circle-fill"
                        style={{
                          position: "relative",
                          right: "45px",
                          bottom: "-3px",
                        }}
                      />
                    )}
                </div>
                <div
                  className="navicons-container"
                  onClick={() => setShowPopup(true)}
                >
                  <i className="pi pi-wallet nav-icons"></i>
                </div>
              </div>
            </div>

            <div className="showadmin-container">
              {/* <img src={admin} className="admin-image" alt="adminphoto"></img> */}
              <div className="admin-info">
                {/* <p className="admin-name" style={{ color: "white" }}>
                  Samson
                </p> */}
                <p className="admin-post" style={{ color: "white" }}>
                  Admin
                </p>
              </div>
            </div>
          </div>
          <Loader isExporting={isExporting} />
          <div className="content-container">
            {activePage === "dashboard" && (
              <Dashboard
                dashactivePage={activePage}
                setDashActivePage={setActivePage}
                setIsExporting={setIsExporting}
              />
            )}
            {activePage === "contactrequest" && (
              <ContactRequest
                isExporting={isExporting}
                setIsExporting={setIsExporting}
              />
            )}
            {activePage === "feedback" && (
              <Feedback
                isExporting={isExporting}
                setIsExporting={setIsExporting}
              />
            )}
            {activePage === "announcement" && <Announcement />}
            {activePage === "registration" && (
              <KBARegistration
                setActivePage={setActivePage}
                showKbaDataTable={showKbaDataTable}
                setShowKbaDataTable={setShowKbaDataTable}
                isExporting={isExporting}
                setIsExporting={setIsExporting}
                showSearch={showSearch}
                isShowSearch={isShowSearch}
                isShowEditIcon={isShowEditIcon}
                setIsShowEditIcon={setIsShowEditIcon}
              />
            )}
            {activePage === "slotbooking" && (
              <SlotBooking
                isExporting={isExporting}
                setIsExporting={setIsExporting}
                showCustomerData={showCustomerData}
                setShowCustomerData={setShowCustomerData}
              />
            )}
            {activePage === "BookingCalander" && (
  <BookingCalander
    isExporting={isExporting}
    setIsExporting={setIsExporting}
  />
)}

            {activePage === "ruwibranch" && <RuwiBranch />}
            {activePage === "ghalabranch" && <GhalaBranch />}
            {activePage === "riyazbranch" && <RiyazBranch />}
          </div>
        </div>
      </div>
      {showPopup && (
        <div className="popup-overlay">
          <div className="popup-box">
            <div className="popup-header">
              <h3>UPDATE AMOUNT</h3>
              <button className="close-btn" onClick={() => setShowPopup(false)}>
                <i className="pi pi-times"></i>
              </button>
            </div>
            <hr className="custom-hr" />
            <div className="popup-body">
              <label>Amount</label>
              <input
                type="number"
                placeholder="Enter Amount..."
                value={price}
                onChange={(e) => setPrice(e.target.value)}
              />
              <div className="popup-footer">
                <span className="current-amount">
                  Current Amount: OMR {currentAmount}
                </span>
                <button className="update-btn" onClick={handleUpdate}>
                  Update
                </button>
              </div>
              {showSnackbar && (
                <div className="snackbar-inside-popup">
                  <img
                    src={accept}
                    className="snackbar-icon"
                    alt="snackbar icon"
                  ></img>
                  <span className="snackbar-text">
                    Amount Updated Successfully
                  </span>
                  <button
                    className="snackbar-close"
                    onClick={() => setShowSnackbar(false)}
                  >
                    <i className="pi pi-times"></i>
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
      {visibleNotificatios && (
        <ShowNotifications
          visibleNotificatios={visibleNotificatios}
          adminNotifications={adminNotifications}
          todayNotifications={todayNotifications}
          yesterdayNotifications={yesterdayNotifications}
          olderNotifications={olderNotifications}
          setAdminNotifications={setAdminNotifications}
          getAdminNotification={getAdminNotification}
          setTodayNotifications={setTodayNotifications}
          setYesterdayNotifications={setYesterdayNotifications}
          setOlderNotifications={setOlderNotifications}
          setVisibleNotifications={setVisibleNotifications}
          setMessages={setMessages}
          groupNotificationsByDate={groupNotificationsByDate}
          onNotificationNavigate={handlePageChange}
        />
      )}
    </>
  );
};

export default Admin;
